import { connect } from '@atlassian/jira-react-redux';
import { globalIssueCreate } from '../../../state/entities/issues/actions';
import Listener from './view';

export default connect(null, {
	onJiraGlobalIssueCreateClosed: globalIssueCreate,
})(Listener);
